import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    minWidth: 480
  },
  hint: {
    marginLeft: 32
  },
  serviceField: {
    marginLeft: 32,
    marginTop: 4,
    maxWidth: 320,
    display: 'flex'
  },
  actions: {
    display: 'flex',
    gap: 12,
    paddingTop: 8
  }
});
export default useStyles;